<template>
	<div class="layer-project" data-project-name="design-samsung">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						<span class="award13"></span>Design SAMSUNG Contents Maintenance
					</h1>
					<a href="http://design.samsung.com" class="link" target="_blank"
						>design.samsung.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->

			<!-- overview -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						삼성전자 국내외 사업부의 제품 및 프로젝트들을 대상으로 디자인적으로
						의미 있는 제품이나 스토리를 발굴하여 콘텐츠를 업데이트하는 디자인
						경영센터의 웹사이트입니다.<br />
						삼성전자의 디자인 철학을 일반 사용자는 물론이고 디자인을 전공하는
						학생과 현업에서 일하고 있는 디자이너들에게 한발 더 깊게 접근
						가능하도록 하는 목적으로 만들어진 사이트입니다.<br />
						커뮤니케이션 컨설팅 그룹인 미스터존스 어소시에이션과 26개월간의
						협업으로 진행된 프로젝트입니다.
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li class="item01">Samsung<br />Design<br />Philosophy</li>
						</ul>
						<ul class="diagram02">
							<li class="item02">Branded<br />Contents</li>
							<li class="item03">UI/UX<br />Design</li>
							<li class="item04">Interactive<br />Design</li>
						</ul>
						<ul class="diagram03">
							<li class="item05">Contents<br />Maintenance</li>
						</ul>
					</div>
				</div>
			</section>

			<!-- section1 : point concept -->
			<section class="section section01">
				<div class="inner-section">
					<dl>
						<dt>
							<span class="number">1</span>Simplicity with <br />Resonance
						</dt>
						<dd>
							비움의 간결미가 <span class="blank tb">감흥을 주는 디자인</span>
						</dd>
					</dl>
					<dl>
						<dt>
							<span class="number">2</span>Balance of Reason <br />and Feeling
						</dt>
						<dd>이성과 감성이 <span class="blank tb">조화된 디자인</span></dd>
					</dl>
					<dl class="last">
						<dt><span class="number">3</span>Meaningful <br />Innovation</dt>
						<dd>
							삶을 즐겁고 의미있게 해주는
							<span class="blank tb">혁신적인 디자인</span>
						</dd>
					</dl>
				</div>
			</section>

			<!-- section2 -->
			<section class="section section02 full">
				<div class="inner-section">
					<div class="con-tit-area">
						<strong class="project-subtit">PC Web</strong>
						<p class="sub-text">
							콘텐츠의 다양성을 강조하고 끊임없이 진화하는
							<span class="blank mb"
								>삼성전자의 디자인 철학을 담아내기 위해 정형화된 </span
							>레이아웃에서 벗어나 Fluid / Flexibility 란 콘셉트 아래 사이트의
							전체 디자인을 새롭게 리뉴얼 하였습니다.
							<span class="blank mb tb"
								>기존의 그리드형 구조에서 과감히 벗어나 콘텐츠의 중요도와 상황에
								따라 변화 가능한 Flexible Banner 형태로 제작되었습니다.</span
							>
						</p>
					</div>
					<div class="detail-img">
						<img
							src=""
							alt="sec2 mobile img"
							data-src="/static/img/project-detail/design-samsung/sec2-content@m.png"
						/>
					</div>
				</div>
			</section>

			<!-- section3 : creating the future -->
			<section class="section section03 full">
				<div class="inner-section">
					<div class="cont-tit-area">
						<strong class="cont-tit"
							>Inspired by humans, creating the future</strong
						>
						<p class="cont-desc">
							Samsung believes in the value of people’s dreams. Therefore, our
							design should begin with empathy for people’s lives.
							<span class="blank pc tb"></span> Samsung strives to create a
							better future with our users.
							<span class="blank mb tb"></span>Together, we can contribute to
							society by creating sustainable values and<span
								class="blank pc"
							></span>
							bring joy and meaning to our lives.
							<span class="blank tb"></span>This is the design to which Samsung
							aspires. To achieve our goals, we pursue three design values.
						</p>
					</div>
					<div class="detail-img">
						<img
							src=""
							alt="sec3 mobile img"
							data-src="/static/img/project-detail/design-samsung/sec3-cont@m.jpg"
						/>
					</div>
				</div>
			</section>

			<!-- section4 : samsung one font -->
			<section class="section section04 full">
				<div class="inner-section">
					<div class="cont-tit-area">
						<strong class="cont-tit">
							<img
								src=""
								alt="sec4 mobile img"
								data-src="/static/img/project-detail/design-samsung/sec4-tit@m.png"
							/>
						</strong>
						<p class="cont-desc">
							<span class="blank mb"
								>삼성전자와 영국의 Neville Brody Association과 함께 </span
							>Samsung One Font를 제작하여 관련 영상 및 콘텐츠를 제작하였습니다.
						</p>
					</div>
				</div>
				<div class="video-area">
					<img
						src=""
						alt="sec4 mobile poster img"
						data-src="/static/img/project-detail/design-samsung/sec4-video-poster@m.jpg"
					/>
				</div>
				<div class="detail-img">
					<p class="cont01">
						<img
							src=""
							alt="sec4 mobile img"
							data-src="/static/img/project-detail/design-samsung/sec4-cont01@m.jpg"
						/>
					</p>
					<p class="cont02">
						<img
							src=""
							alt="sec4 mobile img"
							data-src="/static/img/project-detail/design-samsung/sec4-cont02@m.jpg"
						/>
					</p>
				</div>
			</section>

			<!-- section5 -->
			<section class="section section05 full">
				<div class="inner-section">
					<strong class="project-subtit">Mobile Web</strong>
					<div class="cont-wrap">
						<div class="mobile-swiper">
							<!--swiper-container-->
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<p class="slide-tit">MENU</p>
									<img
										src="/static/img/project-detail/design-samsung/sec5-slide01.png"
										alt="sec5 mobile slider img 01"
									/>
								</div>
								<div class="swiper-slide">
									<p class="slide-tit">MAIN</p>
									<img
										src="/static/img/project-detail/design-samsung/sec5-slide02.png"
										alt="sec5 mobile slider img 02"
									/>
								</div>
								<div class="swiper-slide">
									<p class="slide-tit">AWARDS</p>
									<img
										src="/static/img/project-detail/design-samsung/sec5-slide03.png"
										alt="sec5 mobile slider img 03"
									/>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</section>

			<!-- section6 -->
			<section class="section section06 full">
				<div class="inner-section">
					<div class="cont-wrap clfix">
						<div>
							<img
								src=""
								alt="sec5 content02 mobile img"
								class="menu"
								data-src="/static/img/project-detail/design-samsung/sec5-cont02-sub01@m.png"
							/>
							<img
								src=""
								alt="sec5 content02 mobile img"
								class="main"
								data-src="/static/img/project-detail/design-samsung/sec5-cont02-sub02@m.png"
							/>
							<img
								src=""
								alt="sec5 content02 mobile img"
								class="award"
								data-src="/static/img/project-detail/design-samsung/sec5-cont02-sub03@m.png"
							/>
						</div>
					</div>
				</div>
			</section>

			<!-- <section class="section">
            <a href="javascript:;" class="click-sample" v-on:click.prevent="functionName">Click Test</a>            
        </section> -->
			<!-- Details [e] -->

			<section class="project-client">
				<strong class="a11y-hidden">Make it Meaningful</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".mobile-swiper", {
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
				});
			}
		};

		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}

		$window.on("resize", function () {
			winW = $window.outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
};
</script>
<!-- css 추가 -->
<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Common */
div[class^="rwd"] {
	display: none;
}
.full .inner-section {
	padding: 0;
}
@media screen and (max-width: 711px) {
	div[class="rwd-mb"] {
		display: block;
	}
	.project-visual {
		height: 138.43vw;
	}
	.project-visual > div {
		top: 90px;
		height: 138.43vw;
	}
	.full .detail-img img {
		width: 100%;
	}
	.cont-tit-area {
		padding: 0 15px;
	}
	.cont-desc {
		font-size: 12px;
	}
	.blank.mb {
		display: block;
	}
}
@media screen and (min-width: 712px) {
	div[class="rwd-tb"] {
		display: block;
	}
	.blank.tb {
		display: block;
	}
}
@media screen and (min-width: 1280px) {
	div[class="rwd-tb"] {
		display: none;
	}
	div[class="rwd-pc"] {
		display: block;
	}
	.blank.tb {
		display: inline;
	}
	.blank.pc {
		display: block;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: #eee url(/static/img/project-detail/design-samsung/ci.png) 50% /
		auto 20px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/design-samsung/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/design-samsung/bg-overview@t.jpg);
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/design-samsung/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 42px;
	}
}

/* Overview */
.project-overview {
	background-color: #1b1b1b;
	color: #fff;
}
.project-overview-diagram ul {
	position: relative;
	display: flex;
	justify-content: center;
}
.project-overview-diagram ul:not(.diagram03):before {
	content: "";
	position: absolute;
	background-color: #fff;
}
.project-overview-diagram ul:not(.diagram03):after {
	content: "";
	position: absolute;
	background-color: #fff;
}
.project-overview-diagram ul li {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	text-align: center;
	line-height: 1.2;
}
.project-overview-diagram .diagram01 li {
	background-color: #112aad;
}
.project-overview-diagram .diagram02 li {
	border: 1px solid #fff;
}
.project-overview-diagram .diagram03 li {
	background-color: #000;
}
@media screen and (max-width: 711px) {
	.project-overview-txt {
		margin-bottom: 30px;
	}
	.project-overview-diagram ul li {
		width: 103px;
		height: 103px;
	}
	.project-overview-diagram ul:not(.diagram03) {
		padding-bottom: 70px;
	}
	.project-overview-diagram ul:not(.diagram03):before {
		left: 50%;
		bottom: 15px;
		width: 1px;
		height: 43px;
	}
	.project-overview-diagram ul:not(.diagram03):after {
		left: 50%;
		bottom: 15px;
		width: 1px;
		height: 6px;
		transform: rotate(45deg) translateX(3px);
	}
	.project-overview-diagram .diagram02 .item02 {
		transform: translateX(15px);
	}
	.project-overview-diagram .diagram02 .item04 {
		transform: translateX(-15px);
	}
}
@media screen and (min-width: 712px) {
	.project-overview-txt {
		margin-bottom: 30px;
	}
	.project-overview-diagram {
		display: flex;
		justify-content: center;
	}
	.project-overview-diagram ul li {
		width: 103px;
		height: 103px;
		font-size: 14px;
	}
	.project-overview-diagram ul:not(.diagram03) {
		padding-right: 70px;
	}
	.project-overview-diagram ul:not(.diagram03):before {
		top: 50%;
		right: 0;
		width: 43px;
		height: 1px;
	}
	.project-overview-diagram ul:not(.diagram03):after {
		top: calc(50% - 3px);
		right: 0px;
		width: 8px;
		height: 1px;
		transform: rotate(45deg);
	}
	.project-overview-diagram ul.diagram02:before {
		right: 17px;
	}
	.project-overview-diagram ul.diagram02:after {
		right: 15px;
	}
	.project-overview-diagram ul.diagram02 .item02 {
		transform: translateX(15px);
	}
	.project-overview-diagram ul.diagram02 .item04 {
		transform: translateX(-15px);
	}
}
@media screen and (min-width: 1280px) {
	.project-overview-txt {
		margin-bottom: 53px;
	}
	.project-overview-diagram {
		margin-bottom: 40px;
	}
	.project-overview-diagram ul li {
		width: 207px;
		height: 207px;
		font-size: 22px;
	}
	.project-overview-diagram ul:not(.diagram03) {
		padding-right: 100px;
	}
	.project-overview-diagram ul:not(.diagram03):before {
		right: -10px;
		width: 86px;
	}
	.project-overview-diagram ul:not(.diagram03):after {
		top: calc(50% - 5px);
		right: -12px;
		width: 16px;
	}
	.project-overview-diagram ul.diagram02:before {
		right: 17px;
	}
	.project-overview-diagram ul.diagram02:after {
		right: 15px;
	}
	.project-overview-diagram ul.diagram02 .item02 {
		transform: translateX(28px);
	}
	.project-overview-diagram ul.diagram02 .item04 {
		transform: translateX(-28px);
	}
}

/* section1 : concept */
.layer-project-detail > section.section01 {
	padding-top: 0;
	padding-bottom: 0;
}
.section01 .inner-section {
	display: flex;
	justify-content: center;
}
.section01 dl {
	position: relative;
}
.section01 dl:not(.last):after {
	content: "";
	position: absolute;
	background: #ddd;
}
.section01 dt {
	line-height: 1.2;
}
.section01 dt span {
	position: absolute;
	left: 0;
	color: #d9d9d9;
}
.section01 dd {
	color: #666;
}
@media screen and (max-width: 711px) {
	.section01 .inner-section {
		display: block;
	}
	.section01 dl {
		padding: 30px 37px;
	}
	.section01 dl:not(.last):after {
		left: 0;
		bottom: 0;
		width: 100%;
		height: 1px;
	}
	.section01 dl:nth-child(2) {
		min-width: 255px;
	}
	.section01 dt {
		font-size: 25px;
		word-break: break-all;
		white-space: nowrap;
	}
	.section01 dt span {
		top: 25px;
		font-size: 44px;
	}
	.section01 dd {
		margin-top: 8px;
		font-size: 12px;
	}
}
@media screen and (min-width: 712px) {
	.section01 dl {
		margin: 40px 0;
		padding: 0 22px 0 40px;
		white-space: nowrap;
	}
	.section01 dl:not(.last) {
		margin-right: 17px;
	}
	.section01 dl:not(.last):after {
		right: 0;
		bottom: 0;
		width: 1px;
		height: 100%;
	}
	.section01 dl.last {
		padding-right: 0;
		margin-right: 0;
	}
	.section01 dt {
		font-size: 22px;
	}
	.section01 dt span {
		top: -12px;
		font-size: 44px;
	}
	.section01 dd {
		margin-top: 8px;
		font-size: 12px;
	}
}
@media screen and (min-width: 1280px) {
	.section01 dl {
		margin: 80px 0;
		padding: 0 65px;
	}
	.section01 dl:not(.last) {
		margin-right: 30px;
	}
	.section01 dl:not(.last):after {
		top: 10px;
	}
	.section01 dt {
		font-size: 32px;
	}
	.section01 dt span {
		font-size: 72px;
	}
	.section01 dd {
		margin-top: 20px;
		font-size: 16px;
	}
}

/* section2 : PC Web */
.section02 {
	background-color: #444;
	color: #fff;
}
@media screen and (max-width: 711px) {
	.section02 {
		text-align: center;
	}
	.section02 .sub-text {
		margin-bottom: 25px;
		padding: 0 15px;
		font-size: 14px;
	}
}
@media screen and (min-width: 712px) {
	.section02 .con-tit-area {
		margin-bottom: 34px;
		padding: 0 40px;
	}
}
@media screen and (min-width: 1280px) {
	.layer-project-detail > section.section02 {
		max-width: 1920px;
	}
	.section02 .con-tit-area {
		max-width: 1280px;
		margin: 0 auto;
		padding: 0 20px;
	}
	.section02 .sub-text {
		margin-bottom: 88px;
		font-size: 16px;
	}
}

/* section3 : creating the future */
.section03 {
	text-align: center;
}
@media screen and (max-width: 711px) {
	.section03 .cont-tit {
		font-size: 28px;
		font-weight: 400;
	}
	.section03 .cont-desc {
		margin-bottom: 30px;
		padding: 10px 0;
		font-size: 12px;
	}
}
@media screen and (min-width: 712px) {
	.section03 .cont-tit-area {
		margin-top: 14px;
		padding-bottom: 43px;
		text-align: center;
	}
	.section03 .cont-tit {
		font-size: 28px;
		font-weight: 400;
	}
	.section03 .cont-desc {
		margin: 15px 0;
		font-size: 12px;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .cont-tit-area {
		padding: 70px 0 100px;
	}
	.section03 .cont-tit {
		font-size: 56px;
	}
	.section03 .cont-desc {
		font-size: 16px;
	}
}

/* section4 : samsung one font */
.layer-project-detail > section.section04 {
	padding-top: 0;
	padding-bottom: 0;
}
.section04 {
	text-align: center;
}
.section04 .cont-tit {
	display: block;
}
@media screen and (max-width: 711px) {
	.section04 .cont-tit {
		margin: 6px 0;
	}
	.section04 .cont-tit img {
		width: 77.65vw;
	}
	.section04 .cont-desc {
		margin-bottom: 20px;
	}
	.section04 .video-area {
		margin-bottom: 40px;
	}
}
@media screen and (min-width: 712px) {
	.section04 .cont-tit-area {
		margin-top: 10px;
		padding-bottom: 28px;
	}
	.section04 .cont-tit {
		margin: 11px 0;
	}
	.section04 .cont-tit img {
		width: 298px;
	}
	.section04 .video-area {
		margin-bottom: 60px;
	}
	.section04 .video-area img {
		width: 550px;
	}
}
@media screen and (min-width: 1280px) {
	.section04 .cont-tit-area {
		padding: 58px 0;
	}
	.section04 .cont-tit img {
		width: auto;
	}
	.section04 .cont-tit {
		margin: 22px 0;
	}
	.section04 .video-area {
		margin-bottom: 120px;
	}
	.section04 .video-area img {
		width: auto;
	}
}

/* section5 : mobile web */
.section05 {
	background-color: #ccc;
	text-align: center;
}
.section05 .cont-wrap {
	position: relative;
}
.section05 .mobile-swiper .swiper-slide .slide-tit {
	color: #888;
}
@media screen and (max-width: 499px) {
	.section05 {
		padding-bottom: 30px;
	}
	.section05 .mobile-swiper .slide-tit {
		font-size: 12px;
	}
	.section05 .mobile-swiper .swiper-slide img {
		width: 76.56vw;
		transform: translateX(-6.3vw);
	}
}
@media (min-width: 500px) and (max-width: 711px) {
	.section05 .cont-wrap {
		padding-bottom: 30px;
	}
	.section05 .mobile-swiper .swiper-slide img {
		width: 345px;
		transform: translateX(-28px);
	}
}
@media screen and (min-width: 712px) {
	.section05 .project-subtit {
		display: block;
		padding: 0 40px;
		text-align: left;
		margin: 0 auto 30px;
	}
	.section05 .cont-wrap div {
		text-align: center;
	}
	.section05 .mobile-swiper .swiper-wrapper {
		display: flex;
		justify-content: center;
	}
	.section05 .mobile-swiper .swiper-slide {
		width: 30%;
	}
	.section05 .mobile-swiper .swiper-slide .slide-tit {
		padding-left: 40px;
		font-size: 12px;
		color: #888;
	}
	.section05 .mobile-swiper .swiper-slide img {
		height: 52vw;
	}
}
@media screen and (min-width: 1280px) {
	.layer-project-detail > section.section05 {
		max-width: 1920px;
	}
	.section05 .project-subtit {
		max-width: 1280px;
		margin: 25px auto 60px;
		padding: 0;
	}
	.section05 .mobile-swiper .swiper-wrapper {
		display: flex;
		justify-content: center;
	}
	.section05 .mobile-swiper .swiper-slide {
		width: 26%;
	}
	.section05 .mobile-swiper .swiper-slide .slide-tit {
		padding-left: 90px;
		font-size: 18px;
		color: #888;
	}
	.section05 .mobile-swiper .swiper-slide img {
		height: auto;
	}
}

/* section6 : mobile web */
.layer-project-detail > section.section06 {
	padding-bottom: 0;
}
.section06 {
	background-color: #fff;
}
.section06 .cont-wrap {
	position: relative;
}
.section06 .cont-wrap:before {
	content: "";
	position: absolute;
	background-color: #202020;
	border-radius: 50%;
}
@media screen and (max-width: 499px) {
	.section06 .cont-wrap {
		height: 305.71vw;
		padding-top: 10px;
	}
	.section06 .cont-wrap div {
		position: relative;
		z-index: 10;
	}
	.section06 .cont-wrap div img {
		position: absolute;
		width: auto;
		max-width: none;
		height: 101.25vw;
	}
	.section06 .cont-wrap .menu {
		top: 0;
		left: calc(50% - 19.21vw);
	}
	.section06 .cont-wrap .main {
		top: 92.65vw;
		right: calc(50% - 47.96vw);
	}
	.section06 .cont-wrap .award {
		top: 185.15vw;
		left: calc(50% - 45.46vw);
	}
	.section06 .cont-wrap:before {
		width: 318.7vw;
		height: 234.84vw;
		top: 43.75vw;
		left: calc(50% - 141.87vw);
	}
}
@media (min-width: 500px) and (max-width: 711px) {
	.section06 {
		position: relative;
		padding-top: 10px;
	}
	.section06 .cont-wrap div {
		height: 1423px;
	}
	.section06 .cont-wrap div img {
		position: absolute;
		width: auto;
		max-width: none;
		height: 498px;
	}
	.section06 .cont-wrap .menu {
		top: 50px;
		left: calc(50% - 100px);
	}
	.section06 .cont-wrap .main {
		top: calc(50% - 225px);
		right: calc(50% - 238px);
	}
	.section06 .cont-wrap .award {
		top: calc(50% + 230px);
		left: calc(50% - 230px);
	}
	.section06 .cont-wrap:before {
		width: 1428px;
		height: 1142px;
		top: 255px;
		left: calc(50% - 638px);
	}
}
@media screen and (min-width: 712px) {
	.section06 {
		padding-bottom: 200px;
	}
	.section06 .cont-wrap {
		padding: 20px 0 100px;
		overflow: hidden;
	}
	.section06 .cont-wrap div {
		position: relative;
		text-align: center;
	}
	.section06 .cont-wrap .rwd-tb img {
		height: 54vw;
	}
	.section06 .cont-wrap .menu {
		float: right;
	}
	.section06 .cont-wrap .main {
		float: left;
	}
	.section06 .cont-wrap .award {
		float: right;
	}
	.section06 .cont-wrap:before {
		width: 179.073vw;
		height: 135.95vw;
		top: 28.71vw;
		left: calc(50% - 74.01vw);
		border-radius: 50%;
	}
}
@media screen and (min-width: 1280px) {
	.section06 {
		padding-bottom: 400px;
	}
	.section06 .cont-wrap {
		padding: 80px 0 400px;
		overflow: hidden;
	}
	.section06 .cont-wrap div {
		position: relative;
		text-align: center;
	}
	.section06 .cont-wrap .menu {
		float: none;
	}
	.section06 .cont-wrap .main {
		float: left;
	}
	.section06 .cont-wrap .award {
		float: right;
	}
	.section06 .cont-wrap:before {
		width: 2899px;
		height: 2671px;
		top: 514px;
		left: calc(50% - 1530px);
		border-radius: 50% 49%;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/design-samsung.vue